const THOUSAND_SEPERATOR_REGEX = /\B(?=(\d{3})+(?!\d))/g;
const LAKH_SEPERATOR_REGEX = /\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g;
const THOUSAND = "thousand";
const LAKH = "lakh";
// const WAN = "wan";

const localeDetails = {
    ...[
        "en-us", "en-gb", "en-ca", "en-de", "ja-jp"
        ].reduce((a,c) =>  ({...a,...{[c] : 
            { regex : THOUSAND_SEPERATOR_REGEX, isPrefix : true, delimiter : ",", thousandGroup : THOUSAND}
        }}), {}),
        
    ...[
        "en-in", "hi-in"
        ].reduce((a,c) =>  ({...a,...{[c] : 
            { regex : LAKH_SEPERATOR_REGEX, isPrefix : true, delimiter : ",", thousandGroup : LAKH}
        }}), {}),
    
    "de-de" : { regex : THOUSAND_SEPERATOR_REGEX, isPrefix : false, delimiter : ".", decimalPoint : ',', thousandGroup : THOUSAND},
};

export const userLocale = {
    localeDetails
}